export const BACKLOG = 'backlog';
export const READY = 'ready';
export const DOING = 'doing';
export const REVIEW = 'review';
export const BLOCKED = 'blocked';
export const DONE = 'done';